export default class ShoppyConstants {
    /**
     * OMBD API prefix url. 
     */
    public static OMBD_API_PREFIX = "https://www.omdbapi.com/?";

    /**
     * OMBD Api Key.
     */
    public static OMBD_API_KEY = "beca3c92";
    
    /**
     * Search bar placeholder text.
     */
    public static SEARCH_PLACEHOLDER = "Movie Title";
    /**
     * List title for nominations list.
     */
    public static NOMINATIONS_LIST_TITLE = "Nominations";
    
    /**
     * List title for empty results list.
     */
    public static RESULTS_EMPTY_TITLE = "Results";

    /**
     * List title for empty results list.
     */
    public static NO_SEARCH_PROVIDED = "Please enter a search term.";

    /**
     * Text when no movie results are found. 
     */
    public static RESULTS_EMPTY_MESSAGE = "No results found.";

    /**
     * Text when no nominations have been selected.
     */
    public static NOMINATIONS_EMPTY_MESSAGE = "No nominations selected.";
    
    /** 
     * Text for notification banner when user selects 5 nominations.
     */
    public static NOTIFICATION_TEXT = "You've Selected 5 nominations!";
}